import { RootState } from "../../store";
import { TreeItems } from "../../../components/navigation/components/sortable-tree/utils/types";

export const navigationDashboardDataSelector = (
  state: RootState,
): TreeItems | null => {
  return state.navigation?.dashboard;
};
